import { Component, DestroyRef } from '@angular/core';
import { ModalComponent } from '../modals/modal/modal.component';
import { TranslatePipe } from '../../pipes/translate/translate.pipe';
import { DialogRef } from '@angular/cdk/dialog';
import { IconComponent } from '../ui/icon/icon.component';
import { PwaService } from 'src/app/core/services/pwa/pwa.service';
import { networkActions } from 'src/app/store/features/network/network-actions';
import { Actions, ofType } from '@ngrx/effects';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, filter } from 'rxjs';
import { Store } from '@ngrx/store';
import { appActions } from 'src/app/store/features/app/app-actions';
import { AlertComponent } from '../ui/alert/alert.component';
import { NetworkService } from 'src/app/core/services/network/network.service';
import { LocalStorage } from '@ng-idle/core';

@Component({
  selector: 'pwa-offline-banner',
  standalone: true,
  imports: [ModalComponent, TranslatePipe, IconComponent, AlertComponent],
  templateUrl: './pwa-offline-banner.component.html',
  styleUrl: './pwa-offline-banner.component.scss'
})
export class PwaOfflineBannerComponent {
  public showOfflineBanner: boolean = true;
  public showOnlineBanner: boolean = false;


  public constructor(public pwaService: PwaService, public networkService: NetworkService, private destroyRef: DestroyRef, private store$: Store, private actions$: Actions) {
		this.actions$.pipe(ofType(networkActions.statusChanged), distinctUntilChanged(), takeUntilDestroyed(this.destroyRef)).subscribe({
      next: ({isOnline}) => {
        if(isOnline) {
          this.showOfflineBanner = false;
          if(this.appOffline()){
            this.showOnlineBanner = true;
            setTimeout(() => {
              this.showOnlineBanner = false;
            }, 5000);
          }
        }else{
          this.showOfflineBanner = true;
        }
      }
    });

  }

  public appOffline(): boolean {
    return localStorage.getItem('appOffline') == 'true';
  }


  public close(): void {
    this.showOfflineBanner = false;
  }

  public confirm(): void {
    this.store$.dispatch(appActions.offlineModeChanged({ isOnline: false }))
    this.close();
  }
}
